import { createAction, props } from '@ngrx/store';
import { EstruturaRetornoOutputDto } from '../../domain/DTOs/output/estrutura-retorno.output.dto';
import { EnviarEmailContatoInputDto } from '../../domain/DTOs/input/enviar-email-contato.input.dto';

const actionName = "[FaleConosco ] Enviar Email";

export const enviarEmailContato = createAction(
  actionName,
  props<{ enviarEmailContatoInputDto: EnviarEmailContatoInputDto}>()
);

export const enviarEmailContatoSuccess = createAction(
  `${actionName} - Sucesso`,
  props<{ response: EstruturaRetornoOutputDto }>()
);

export const enviarEmailContatoFailure = createAction(
  `${actionName} - Falha`,
  props<{ response: EstruturaRetornoOutputDto }>()
);

export const enviarEmailContatoFinish = createAction(
  `${actionName} - Concluir`
);
